import React from 'react';
import Select from 'react-select';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';
import sortasc from '../../../img/sort-asc.svg';
import sortdesc from '../../../img/sort-desc.svg';
import check from '../../../img/check.svg';
import emptybox from '../../../img/emptybox.svg';



export default class EventVolunteerSelectScreen extends React.Component {

    constructor(props) {
        super(props);

        var eventid = null
        var sortField = null
        var sortOrder = null
        var pageCount = 0
        var event = null
        
        const args = props.args === undefined ? {} : props.args

        if (args.event !== undefined) {
            event = args.event
        }

        if (args.eventid !== undefined) {
            eventid = args.eventid
        }

        if (args.pageCount !== undefined) {
            pageCount = args.pageCount
        }

        if (args.sortField !== undefined) {
            sortField = args.sortField
        }

        if (args.sortOrder !== undefined) {
            sortOrder = args.sortOrder
        }

        this.state = {args: args,
                      pageLimit: 25, 
                      pageCount: pageCount,   
                      nameCriteria: "",
                      prevNameCriteria:"",
                      eventid: eventid,
                      event: event,
                      sortField: sortField, 
                      sortOrder: sortOrder,
                      volunteers: [],
                      selected: []};

              

        this.nameSearch = this.nameSearch.bind(this);  
        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this);  
        this.sortClicked = this.sortClicked.bind(this)
        this.setBuzyTime = this.setBuzyTime.bind(this)

        setTimeout(this.nameSearch, 2000);
    }

    async componentDidMount() {
        this.getDataWithCritera()
    }

    nameCriteriaChangeHandler(event) {
        this.setState({nameCriteria: event.target.value})
    }


    getDataWithCritera() {

        var parameters = {}

        if (this.state.eventid) {
            parameters.eventid = this.state.eventid
        } 

        if (this.state.event.institutionid) {
            parameters.instituteid = this.state.event.institutionid
        } 

        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

        parameters.limit = this.state.pageLimit
        parameters.offset = this.state.pageLimit * this.state.pageCount

        if (this.state.sortField) {
            parameters.orderby = this.state.sortField
        }

        if (this.state.sortOrder) {
            parameters.sortorder = this.state.sortOrder
        }

        BaseApi.get('/event/volunteers/select', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({volunteers: res.data})
        })    
        .catch(error=>console.log(error))
    }

    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            var args = this.state.args
            args.pageCount = 0
            this.setState({prevNameCriteria: this.state.nameCriteria, pageCount: 0, args: args}, this.getDataWithCritera)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    nextPage() {
        var args = this.state.args
        args.pageCount = this.state.pageCount + 1
        this.setState({pageCount: this.state.pageCount + 1}, this.getDataWithCritera)
    }

    prevPage() {
        if (this.state.pageCount > 0) {
            var args = this.state.args
            args.pageCount = this.state.pageCount - 1
            this.setState({pageCount: this.state.pageCount - 1, args: args}, this.getDataWithCritera)
        }
    }

    sortClicked(event) {
        var currentField = this.state.sortField
        var currentOrder = this.state.sortOrder
        switch (event.target.id) {
            case "nameCaption" :
                if (currentField === "name") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "name"
                    currentOrder = "asc"
                }
            break 
            case "locationCaption" :
                if (currentField === "locationCaption") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "locationCaption"
                    currentOrder = "asc"
                }
            break           
        }
        var args = this.state.args
        args.pageCount = 0
        args.sortField = currentField
        args.sortOrder = currentOrder
        this.setState({sortField: currentField, sortOrder: currentOrder, pageCount: 0}, this.getDataWithCritera)
    }

    isFieldSortedDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc"
    }

    isFieldSortedAsc(field) {
        return this.state.sortField === field && this.state.sortOrder !== "desc"
    } 

    save() {
        BaseApi.post('/event/volunteer', this.state.selected, {headers: {
            'Content-Type': 'application/json', 'SESSIONID': sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.props.goback(this.props.args)
        })
        .catch(error=>console.log(error))
    }

    switchSelected(id) {
        var selected = this.state.selected

        if (this.isSelected(id)) {
            selected = selected.filter(item => item.volunteerid !== id)
        } else {
            selected.push({volunteerid: id, eventid: this.state.eventid, occupation: this.state.event.occupation})
        }

        this.setState({selected: selected})
    }

    isSelected(id) {
        return this.state.selected.filter(item => item.volunteerid === id).length > 0
    }
    
    setBuzyTime(event) {
        
        const id = event.target.id
        const value = event.target.value
        const idx = this.state.selected.findIndex(item => item.volunteerid == id)
        var selected = this.state.selected
        console.log(idx)
        if (idx < 0) {
            selected.push({volunteerid: id, eventid: this.state.eventid, occupation: value})
            console.log("==========")
            console.log(selected)
        } else {
            selected[idx].occupation = value
        }
        this.setState({selected: selected})
    }

    getBuzyTime(id) {
        const item = this.state.selected.find(item => item.volunteerid == id)
        if (item === undefined) {
            return 0
        } else {
            return item.occupation
        }
    }

    renderVolunteer(volunteer) {
    
        return (
            <tr>
                <td style={{textAlign: 'left',  padding: '4px'}}>{volunteer.name}</td>
                <td style={{textAlign: 'left',  padding: '4px'}}>{volunteer.location}</td>
                <td style={{textAlign: 'left',  padding: '4px'}}>{volunteer.phone}</td>
                <td 
                    onClick={()=>{this.switchSelected(volunteer.id)}}>
                    {this.isSelected(volunteer.id) && <img src={check} height="16" width="16"/>}
                    {!this.isSelected(volunteer.id) && <img src={emptybox} height="16" width="16"/>}
                </td>
                <td>
                    <input  class="w-25"
                            type="number" 
                            name= "buzytime" 
                            id={volunteer.id} 
                            value={this.getBuzyTime(volunteer.id)}
                            onChange={this.setBuzyTime}
                    />
                </td>
            </tr>
        )        
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Добавить участников к событию"}/>
                <div className="row mt-4 mb-3">
                    <div className="col-lg-6">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Фильтр</h6>
                                <div className="mb-3">
                                    <label htmlFor="name" className="form-label">Имя</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        value={this.state.nameCriteria}
                                        onChange={this.nameCriteriaChangeHandler}
                                        placeholder="Введите ФИО или часть имени"
                                    />
                                </div>
                            </div>                        
                        </div>
                    </div> 
                    <div className="col-lg-6 d-flex flex-column align-items-end mt-3 mt-lg-0">
                        <div className="mb-2">
                            <button
                                type="button"
                                className="btn btn-primary d-flex align-items-center"
                                onClick={() => this.save()}
                            >
                                Сохранить
                            </button>
                        </div>

                        <div>
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm me-2"
                                onClick={() => this.prevPage()}
                                disabled={this.state.pageCount === 0}
                            >
                                Предыдущие
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => this.nextPage()}
                            >
                                Следующие
                            </button>
                        </div>
                    </div>
                </div>
                
            
                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th id="nameCaption"    
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                            onClick={this.sortClicked}
                                        >
                                            ФИО{" "}
                                            {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                                            {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                                        </th>
                                        <th id="locationCaption" 
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                            onClick={this.sortClicked}
                                        >
                                            Локация{" "}
                                            {this.isFieldSortedDesc("location") && <img src={sortdesc} height="16" width="16"/>}
                                            {this.isFieldSortedAsc("location") && <img src={sortasc} height="16" width="16"/>}
                                        </th>
                                        <th id="locationCaption" 
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                        >
                                            Телефон    
                                        </th>
                                        <th id="selectCaption" 
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                        >
                                            Выбор
                                        </th>    
                                        <th 
                                            id="buzyCaption" 
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                        >
                                            Часы
                                        </th>        

                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.volunteers.map((value, index) => this.renderVolunteer(value))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/event/volunteers-select.js